/*
[GNU Affero General Public License (AGPL)](https://www.gnu.org/licenses/agpl-3.0.html)

VeloceUI - A UI component library for Angular v17+ made with care by Colibryx Srl in Italy.
Copyright (C) 2025 Colibryx S.r.l.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

This license applies to any accompanying files located directly in the same directory.

For any inquiry, please contact Colibryx S.r.l. at info@colibryx.com.
*/

import {
	ChangeDetectionStrategy,
	Component,
	TemplateRef,
	ViewEncapsulation,
	contentChild,
	input
} from "@angular/core";
import { globalControlsKey } from "../layout-global-controls/layout-global-controls.component";

export type LayoutItemType =
	| "title"
	| "global-controls"
	| "controls"
	| "tabs"
	| "filters"
	| "custom";

@Component({
	selector: "cb-layout-item",
	templateUrl: "./layout-item.component.html",
	styleUrl: "./layout-item.component.scss",
	encapsulation: ViewEncapsulation.None,
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutItemComponent {
	public readonly globalControlsKey = globalControlsKey;

	public readonly type = input<LayoutItemType>("custom");

	public readonly icon = input("");
	public readonly title = input("");
	public readonly subtitle = input("");
	public readonly hierarchy = input<"primary" | "secondary">("primary");

	readonly before = contentChild("Before", { read: TemplateRef });
	readonly after = contentChild("After", { read: TemplateRef });
}
